// extracted by mini-css-extract-plugin
export default {"LoseScreen":"LoseScreen_LoseScreen__S-GGv","textSection":"LoseScreen_textSection__hj2gW"};